import React from 'react';
import { Award, Compass, Users, ShieldCheck, TrendingUp, Home } from 'lucide-react';
import { whyChooseData } from '../data/mock';

const iconMap = {
  'award': Award,
  'compass': Compass,
  'users': Users,
  'shield-check': ShieldCheck,
  'trending-up': TrendingUp,
  'home': Home
};

export const WhyChoose = () => {
  return (
    <section id="why-choose" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Why Choose Assetree
          </h2>
          <p className="text-lg text-charcoal-400 max-w-2xl mx-auto">
            Built on a foundation of trust, excellence, and customer satisfaction
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {whyChooseData.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={index}
                className="group bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-gold-200"
              >
                {/* Icon */}
                <div className="mb-5">
                  <div className="w-14 h-14 rounded-lg bg-gold-100 flex items-center justify-center group-hover:bg-gold transition-colors duration-300">
                    <IconComponent 
                      size={28} 
                      className="text-gold group-hover:text-navy transition-colors duration-300" 
                    />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-charcoal mb-3">
                  {item.title}
                </h3>
                <p className="text-charcoal-400 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
